import { MatchGroup, Tournament } from '.';

export class Round {

    constructor(data) {
        this.id = data && data.id ? data.id : undefined;
        this.tournament = data && data.tournament ? new Tournament(data.tournament) : null;
        this.number = data && data.number ? data.number : undefined;
        this.start_date = data && data.start_date ? data.start_date : undefined;
        this.end_date = data && data.end_date ? data.end_date : undefined;
        this.kind = data && data.kind ? data.kind : "";
        this.is_open = data && data.is_open ? data.is_open : undefined;

        this.matchgroup_round_set = [];
        if(data && data.matchgroup_round_set) {
            this.matchgroup_round_set = data.matchgroup_round_set.map((item) => new MatchGroup(item));
        }
    }
}